import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { ActivatedRoute, Router } from "@angular/router";
import { concat } from 'rxjs/operator/concat';
import { DialogComponent } from './dialog/dialog.component';

import { MatDialog } from '@angular/material';
import { AngularFirestore } from 'angularfire2/firestore';


@Component({
    selector: 'app-userlist-photo',
    templateUrl: './userlist-photo.component.html',
    styleUrls: ['./userlist-photo.component.scss']
})
export class UserlistPhotoComponent implements OnInit, OnDestroy {

    rows: any[];
    loadingIndicator = true;
    reorderable = true;
    queryString: any;
    length: any;
    private sub: any;
    post: any;

    constructor(private http: HttpClient, private route: ActivatedRoute,
        private afs: AngularFirestore,
        private router: Router, private dialog: MatDialog) {

    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(params => {
            this.queryString = this.route.snapshot.queryParams['name'];
        });

        this.afs.collection('posts').doc(this.queryString).ref.get().then((res => {
            // this.rows.push(res.data());
            this.length = res.data().length;
            this.loadingIndicator = false;
            this.post = res.data();
            this.post.text = (this.post.text).replace(/href="/g, 'href="https://big-advice.firebaseapp.com/');

        }));

    }
    censorContent(key) {
        this.dialog.open(DialogComponent, {

            data: {
                key: key
            }
        });
    }
    back() {
        window.history.back();

    }

    ngOnDestroy(): void {
        // this.sub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/userlist-photo/userlist-photo.component.ts